import React from 'react'

const itemPropType = React.PropTypes.shape({
  id: React.PropTypes.string,
  name: React.PropTypes.string,
})

export default itemPropType



// WEBPACK FOOTER //
// ./src/item-prop-type.js